var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.96875C12.2539 8.96875 9.21875 12.0039 9.21875 15.75C9.21875 19.4961 12.2539 22.5312 16 22.5312C19.7461 22.5312 22.7812 19.4961 22.7812 15.75C22.7812 12.0039 19.7461 8.96875 16 8.96875ZM18.5156 17.5273L17.9688 18.2109C17.8867 18.3203 17.7773 18.4023 17.6133 18.4023C17.5312 18.4023 17.4219 18.3477 17.3672 18.293L15.5352 16.9258C15.2617 16.7344 15.125 16.4336 15.125 16.0781V11.8125C15.125 11.5938 15.3164 11.375 15.5625 11.375H16.4375C16.6562 11.375 16.875 11.5938 16.875 11.8125V15.75L18.4609 16.9258C18.543 17.0078 18.625 17.1172 18.625 17.2539C18.625 17.3633 18.5703 17.4727 18.5156 17.5273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.65134a7adb6bcf97451ef0de117214e9.svg";
export { ForwardRef as ReactComponent };